<div class="full-width flex justify-end">
  <div class="flex center">
    <div class="margin-right-small">{{startNumber}} - {{endNumber}} of {{totalNumber}}</div>
    <button class="icon-button"
            [disabled]="!pageNumber"
            (click)="onClickPage(pageNumber - 1)">
      <i class="fa fa-angle-left"></i>
    </button>
    <button class="icon-button"
            [disabled]="totalNumber === endNumber"
            (click)="onClickPage(pageNumber + 1)">
      <i class="fa fa-angle-right"></i>
    </button>
  </div>
</div>
